import React from 'react';

import ProfileIdentification from './ProfileIdentification';
import ProfileDealerAddress from './ProfileDealerAddress';

const ProfileRoutes = () => {
  return (
    <>
      <ProfileIdentification />
      <ProfileDealerAddress />
    </>
  );
};

export default ProfileRoutes;
